import type { ButtonProps } from '@/components/ui'
import { useAccount, useCheckout } from '@/modules/account'

interface ProcessButtonProps extends ButtonProps {
  isBlocked?: boolean
  validationBehaviour: 'message' | 'hidden' | 'disable-only'
}

export const LegacyMessage = ({
  isBlocked,
  validationBehaviour,
}: ProcessButtonProps) => {
  const account = useAccount()
  const { openCustomerPortal } = useCheckout()

  if (!isBlocked) return
  if (validationBehaviour !== 'message') return
  if (account?.planKind !== 'legacy_subscription') return

  return (
    <span className="text-muted-foreground flex items-center gap-1 text-xs">
      Account limit reached.
      <button
        className="text-brand underline cursor-pointer"
        onClick={openCustomerPortal}
        type="button"
      >
        Upgrade your plan
      </button>
    </span>
  )
}
